export default __webpack_public_path__ + "static/media/afterHero1.e549abe6.png";